<script lang="ts">
  import Dialog from '@/components/dialog/Dialog.svelte';
  import {RecapService} from '@/services';
  import {recap} from '@/store';

  import Swal from 'sweetalert2';

  export let isConfirmationDialogVisible = false;
  let isDownloadRequestSent = false;

  const recapService = new RecapService();

  async function requestDownload() {
    try {
      const response = await recapService.render($recap);

      console.log('response DOWNLOAD', response);

      isDownloadRequestSent = true;
    } catch (error) {
      isConfirmationDialogVisible = false;
      Swal.fire({
        text: 'Something went wrong requesting to download your sermon recap. Please try again',
        icon: 'error',
        titleText: 'Failed to request a download'
      });
    }
  }

  $: if (!isConfirmationDialogVisible) isDownloadRequestSent = false;
</script>

<Dialog isDialogOpen={isConfirmationDialogVisible}>
  <div class="pointer-events-none flex h-full w-full items-center justify-center">
    <div class="pointer-events-auto h-auto w-full rounded-2xl bg-zinc-100 pb-12 pt-6" style="max-width: 540px;">
      <div class="flex w-full items-center justify-end px-6">
        <button on:click={() => (isConfirmationDialogVisible = false)}>
          <i class="fa-solid fa-xmark text-3xl" aria-hidden="true"></i>
        </button>
      </div>
      {#if !isDownloadRequestSent}
        <div class="flex h-full flex-col items-center justify-center px-6 pt-8">
          <div class="flex w-full items-center justify-center pb-6">
            <i class="fa-solid fa-hourglass-start text-6xl font-bold text-rose-500" aria-hidden="true"></i>
          </div>
          <h1 class="pb-4 text-2xl font-bold text-rose-500">Finalize your video</h1>
          <p class="text-center">
            Downloading might require somet time, so please<br />ensure all your edits are final before downloading.
          </p>
          <div class="flex items-center justify-center gap-2 pt-4">
            <button
              on:click={() => (isConfirmationDialogVisible = false)}
              class="rounded-lg border border-zinc-300 px-6 py-2 text-zinc-500">Back to Editor</button
            >
            <button on:click={() => requestDownload()} class="rounded-lg bg-rose-500 px-6 py-2 text-zinc-100"
              >Download</button
            >
          </div>
        </div>
      {:else}
        <div class="flex h-full flex-col items-center justify-center px-6 pt-8">
          <div class="flex w-full items-center justify-center pb-6">
            <i class="fa-solid fa-circle-check text-6xl font-bold text-rose-500" aria-hidden="true"></i>
          </div>
          <h1 class="pb-4 text-2xl font-bold text-rose-500">We got your request!</h1>
          <p class="text-center">
            Downloading your clip may take a while.<br />We'll send you an <span class="text-rose-500">email</span> with
            a link to your video once it's ready.
          </p>
          <div class="flex items-center justify-center gap-2 pt-4">
            <button
              on:click={() => (isConfirmationDialogVisible = false)}
              class="rounded-lg bg-rose-500 px-6 py-2 text-zinc-100">Back to Editor</button
            >
          </div>
        </div>
      {/if}
    </div>
  </div>
</Dialog>
